import React from 'react'

export const bloxDetail = [
  {
    name: 'blox detail',
    component: React.lazy(() => import('../../modules/public/bloxDetail')),
    path: '/public/blox/:id',
    guards: ['allowOnlyLogged'],
  },
]
